import React, { useContext, useEffect } from 'react';
import { AgendaStreamingContext } from '../../../common/AgendaStreamingContextProvider';
import MessageInfo from '../../../common/MessageInfo';
import MainContext from '../../../contexts/MainContext';
import { getMatchStreamingProps, getStreamingId } from '../../../data/streaming/streamingUtils';
import { getConfiguration, iconCategoryCssClass, iconSportCssClass } from '../../../data/utils';
import { WidgetContext } from '../../../data/widgets/WidgetContext';
import { getLabel } from '../../../InitData';
import Streaming from '../Streaming';
import Jersey from '../../../common/jerseys/Jersey';
import { useFetch } from '../../../data/fetch/useFetch';
import { parseLiveData } from '../../../data/parseLiveData';
import LiveSuiteCompetition from '../../live-suite/LiveSuiteCompetition';

function AgendaStreamingCompetition(props) {
    const conf = getConfiguration();
    const mainContext = useContext(MainContext);
    const widgetContext = React.useContext(WidgetContext);
    const agendaStreamingContext = useContext(AgendaStreamingContext);
    const match = agendaStreamingContext.currentMatch;
    const icoSport = match && iconSportCssClass(match.sportRef, match.iconClassSport);
    const icoCategory = match && iconCategoryCssClass(match.sportRef, match.categoryRef, match.iconClassCountry);
    const showLiveSuiteCompetition = agendaStreamingContext.agendaStreamingTemplate == 'V1';
    const [isLoading, isError, data] = useFetch(conf.api.getMenuLiveGenerale, {sportId:match?.sportRef}, (data) =>
                                                parseLiveData(data, false),
                                                showLiveSuiteCompetition && match  
    );

    useEffect(function() {
        if (match) {
            const streamingProps = getMatchStreamingProps(match);
            const streamingId = streamingProps && getStreamingId(streamingProps[match.id]);
            const streamingInfo =  streamingProps && streamingProps[match.id];
            mainContext.toggleStreaming(streamingInfo,streamingId,match.id);
        }

        return () => {
            mainContext.toggleStreaming(null,null,null);
            widgetContext.setWidget({
                isWidgetToggleable: true
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [agendaStreamingContext.currentMatch]); 

    const liveMatch = data?.sportById[match?.sportRef]?.categoryById?.[match?.categoryRef]?.tournamentById[match?.tournamentRef]?.matchById[match?.matchId];


    return (
        <>
            {match ? 
                <>
                    <div className="titolo-blocco-sport bg-nero bianco">
                        <div className="d-flex justify-content-between align-items-center w-100" >
                            <div className={`img-fluid ico-sport mr-1 ${icoSport }`}></div>
                            <div className={`img-fluid ico-sport mr-1 ${icoCategory}`}></div>
                            <div className="d-flex flex-column">
                                <div className="d-flex items-center">
                                    {match.team2 &&
                                        <Jersey data={match.jerseys?.[0]} type={'home'} sportRef={match.sportRef} />
                                    }
                                    <p className="nome-partita-sport">{match.team1}</p>
                                </div>
                                {match.team2 &&
                                    <div className="d-flex items-center">
                                        <Jersey data={match.jerseys?.[1]} type={'away'} sportRef={match.sportRef} />
                                        <p className="nome-partita-sport">{match.team2}</p>
                                    </div>
                                }
                            </div>
                            <p className="data-orario-partita-sport d-flex justify-content-end align-items-center margine-sx">
                                {match.date.formatted}
                            </p>
                        </div>
                    </div>
                    {match.str ?
                        <>
                        <Streaming />  
                        {showLiveSuiteCompetition && liveMatch && 
                            <LiveSuiteCompetition match={liveMatch} isAgendaStreamingCompetition={true} />
                        }
                        </>
                        :
                        match.strOver ?
                            <MessageInfo message={getLabel('live_page.stream_widget.ended')} />
                            :
                            <MessageInfo message={getLabel('live_page.stream_widget.not_started')} />
                    }
                </>
                :
                <MessageInfo message={getLabel('live_page.stream_widget.select_event')} />
            }
        </>
    );
}
            
export default AgendaStreamingCompetition;